export const genericMessage = 'Oops! Something went wrong. Please try again or contact TeamSnap support for help.';

export function parseErrorMessage(e: any, fallbackMessage?: string): string {
  if (e?.response?.status === 500) {
    return genericMessage;
  }
  if (e?.response?.data){
    return e.response.data.error || e.message;
  }
  return fallbackMessage || genericMessage;
}
export const SENTRY_TAGS_PRE = {
  feature: 'POST_REG_EDITS',
};
